module.exports = __webpack_public_path__ + "img/cowork-purple.b9e3c44f.svg";